import React, {useEffect, useState} from 'react';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {MessageAlert} from '../../utils';
import {
  IFTTTIntegrationEventNameFeatureDescription,
  IFTTTIntegrationKeyFeatureDescription,
} from '../../../../system/FeatureDescriptionModal';

export const IFTTTIntegration = ({
  onConfigUpdate,
  validateAndGet,
  configuration,
}) => {
  const [eventNameError, setEventNameError] = useState(undefined);

  const [keyError, setKeyError] = useState(undefined);

  useEffect(() => {
    validateAndGet(() => {
      let isValid = true;

      if (configuration.eventName === undefined) {
        setEventNameError('Event name should not be empty');
        isValid = false;
      }

      if (configuration.key === undefined) {
        setKeyError('Key should not be empty');
        isValid = false;
      }

      return isValid;
    });
    // eslint-disable-next-line
  }, [configuration]);

  return (
    <>
      <Form.Group as={Row}>
        <Form.Label column sm="2">
          Event name {<IFTTTIntegrationEventNameFeatureDescription />}
        </Form.Label>
        <Col sm="3">
          <Form.Control
            as="input"
            value={configuration.eventName}
            onChange={(e) => {
              onConfigUpdate({...configuration, eventName: e.target.value});
              setEventNameError(undefined);
            }}
          />
        </Col>
      </Form.Group>

      <MessageAlert message={eventNameError} />
      <Form.Group as={Row}>
        <Form.Label column sm="2">
          Key {<IFTTTIntegrationKeyFeatureDescription />}
        </Form.Label>
        <Col sm="3">
          <Form.Control
            as="input"
            value={configuration.key}
            onChange={(e) => {
              onConfigUpdate({...configuration, key: e.target.value});
              setKeyError(undefined);
            }}
          />
        </Col>
      </Form.Group>

      <MessageAlert message={keyError} />
    </>
  );
};
